import {Component, OnInit, Input} from '@angular/core';
import {AppConfigService} from './../../service/app-config.service';
import {UtilsService} from './../../service/utils.service';
import {ConfirmModalService} from './../../service/confirm-modal.service';
import {DataCenterService} from './../../service/data-center.service';
import {UserInfoService} from './../../service/user-info.service';
import {RequestDataService} from './../../service/request-data.service';
import * as _ from 'underscore';

@Component({
    selector: 'app-menu-btn',
    templateUrl: './menu-btn.component.html',
    styleUrls: ['./menu-btn.component.css']
})
export class MenuBtnComponent implements OnInit {
    public listMenuBtn: any = [];//当前选中菜单下的按钮
    public menubtnvisible: any;//控制添加按钮和全选显示
    public btnvisible: any;//控制删除按钮显示
    public helpUrl: any;//邦助文档地址
    public menuArray: any = [];
    public checkUniq: any;
    @Input() parentData: any;
    public uniqIndex: any = 0;
    public isVisible: any = false;
    public listAction: any;
    public searchMenu: string;//过滤菜单
    public searchAction: string;//新增按钮弹出框筛选值
    public checkBtnArray: any = [];
    public menuId: any = "";//选中的菜单id
    constructor(private utils: UtilsService,
                private confirmModal: ConfirmModalService,
                private dataCenter: DataCenterService,
                private appConfigService: AppConfigService,
                private userInfo: UserInfoService,
                private requestData: RequestDataService) {
    }

    //查询菜单按钮
    doCheckMenu(pOneMenu) {
        this.checkUniq = false;
        let menuCondition = {
            "MENU_ID": pOneMenu.MENU_ID
        }
        this.requestData.getDataByCondition(this.appConfigService.config.sql_path + '/system/system_menu_action.json', menuCondition).subscribe((response) => {
            this.listMenuBtn = response["data"];
            _.each(this.listMenuBtn, (OneBtn) => {
                OneBtn["selected"] = true;
            });
            this.menubtnvisible = true;
            // ('通过 ajax 得到选中的菜单有的权限按钮',vm.listMenuBtn);
            if (response["data"].length === 0) {
                this.btnvisible = false;
            } else if (response["data"].length !== 0) {
                this.btnvisible = true;
            }

        }, (error) => {
            this.utils.Base_Errored(error);
        });
    }

    //全选／反选而
    selectAll(checked) {
        _.each(this.listMenuBtn, oneData => {
            oneData["selected"] = checked;
        })
    }

    //删除
    actionDel() {
        this.confirmModal.show('confirm', {
            title: '是否确定删除',
            suc: () => {
                _.each(this.listMenuBtn, (OneBtn) => {
                    if (OneBtn["selected"] === true) {
                        this.listMenuBtn = _.without(this.listMenuBtn, OneBtn);
                    }
                });
            }
        })
    }


    //保存
    async roleSave() {
      let that = this
      let menuId = that.menuId;
      let actionsArray = [];
      _.each(that.listMenuBtn, (OneBtn) => {
        if (OneBtn["selected"]) {
          if (that.utils.Base_HasValue(OneBtn["UNIQ_INDEX"]) && !that.checkUniq) {
            that.uniqIndex = OneBtn["UNIQ_INDEX"];
          }
          let actionObject = {
            "actionId": OneBtn["ACTION_ID"],
            "actionOrder": OneBtn["ACTION_ORDER"],
            "actionType": OneBtn["ACTION_TYPE"]
          };
          actionsArray.push(actionObject);
        }
      });
      if (!that.utils.Base_HasValue(menuId)) {
        that.confirmModal.show('error', {title: "请选择菜单",})
        return;
      }
      if (that["checkUniq"]) {
        if (that.uniqIndex > 0) {
          that.uniqIndex = 0;
        } else {
          that.uniqIndex = 1;
        }
      }

      const saveRes = await this.requestData.doMenuToAction(menuId, actionsArray).toPromise();
      if (saveRes.state === 'success') {
        this.confirmModal.show('success', {'title': '保存成功'});
      } else {
        this.confirmModal.show('error', {'title': '保存失败，请刷新重试'});
      }

    }

    //将新增选中的按钮放入数组中。
    log(value: any): void {
        this.checkBtnArray = value;
    }

    checkMenuBtn(pData) {
        pData.selected = !pData.selected;
    }

    // 精简套装
    streamlinedSuit() {
        if (this.utils.Base_HasValue(this.listMenuBtn)) {
            return;
        }
        this.requestData.getDataByCondition(this.appConfigService.config.sql_path + '/system/system_action.json', {'ACTION_TEXT': "公共","U_DELETE":1}).subscribe(values => {
            let actionList = values["data"];
            _.each(actionList, oneData => {
                if (oneData['ACTION_VALUE'] === 'add' || oneData['ACTION_VALUE'] === 'edit' || oneData['ACTION_VALUE'] === 'delete' || oneData['ACTION_VALUE'] === 'save') {
                    oneData["selected"] = true;
                    this.listMenuBtn.push(oneData);
                }
            })
        })
    }

    //添加
    showModal(): void {
        this.isVisible = true;
        this.requestData.getDataByCondition(this.appConfigService.config.sql_path + '/system/system_unselect_action.json').subscribe(values => {
            this.listAction = values["data"];
        })
    }

    handleOk(): void {
        let actionArr = [];
        let that = this;
        _.each(that.checkBtnArray, oneActionId => {
            let iCount = 0;
            _.each(that.listMenuBtn, oneBtn => {
                if (oneActionId === oneBtn["ACTION_ID"]) {
                    iCount++;
                }
            });
            if (iCount < 1) {
                _.each(that.listAction, oneAction => {
                    if (oneActionId === oneAction["ACTION_ID"]) {
                        oneAction["selected"] = true;
                        that.listMenuBtn.push(oneAction);
                    }
                })
            }
        })
        this.isVisible = false;
        this.searchAction = null;
    }

    handleCancel(): void {
        this.isVisible = false;
        this.searchAction = null;
    }

    // 刷新
    refreshData() {
        if (this.utils.Base_HasValue(this.menuId)) {
            let currentMenu = this.utils.Base_getApplist(this.dataCenter._dataObject.nowMenu.MENU_ID);
            if (this.utils.Base_HasValue(currentMenu)) {
                this.helpUrl = currentMenu.HELP_URL;
            }

            let menuCondition = {
                "MENU_ID": this.menuId
            }
            this.requestData.getDataByCondition(this.appConfigService.config.sql_path + '/system/system_menu_action.json', menuCondition).subscribe((response) => {
                this.listMenuBtn = response["data"];
                _.each(this.listMenuBtn, (OneBtn) => {
                    OneBtn["selected"] = true;
                });
                this.menubtnvisible = true;
                if (response["data"].length === 0) {
                    this.btnvisible = false;
                } else if (response["data"].length !== 0) {
                    this.btnvisible = true;
                }
            }, (error) => {
                this.utils.Base_Errored(error);
            });
        }
    }

    ngOnInit() {
        let currentMenu = this.utils.Base_getApplist(this.dataCenter._dataObject.nowMenu.MENU_ID);
        if (this.utils.Base_HasValue(currentMenu)) {
            this.helpUrl = currentMenu.HELP_URL;
        }

        let menuConditon = {
            "MENU_LV": 2
        }
        this.requestData.getDataByCondition(this.appConfigService.config.sql_path + '/system/system_app_menu.json', menuConditon).subscribe(values => {
            let listMenu = values["data"];
            let menuList = _.groupBy(listMenu, oneData => {
                return oneData["UP_ID"];
            });
            _.each(menuList, (value, key) => {
                this.menuArray.push({value});
            });
        })

    }
}
